import { ListOptionsQueryVariables } from '@akin-home/amplify';
import { optionGraphqlToModel, OptionType } from '@akin-home/options';
import {
  listAllOptionsQuery,
  updateOptionMutation,
} from '@akin-home/options/frontend';
import { createQueryKeySet } from '@akin-home/utils/react-query';
import { useMutation, useQuery } from 'react-query';

export * from './useCreateOption';

export const options_query_keys = createQueryKeySet({ key: 'options' });

export const useListOptions = (params?: ListOptionsQueryVariables) =>
  useQuery(options_query_keys.list(params), () => listAllOptionsQuery(params), {
    select: (data) => data.map(optionGraphqlToModel),
  });

export const useListOptionsByType = (params: { type: OptionType }) =>
  useQuery(
    options_query_keys.list(params),
    () => listAllOptionsQuery({ filter: { type: { eq: params.type } } }),
    {
      select: (data) => data.map(optionGraphqlToModel),
    }
  );

export const useUpdateOptionMutation = (options?: any) =>
  useMutation(updateOptionMutation, options);